<template>
    <div v-loading="dataLoading">
        <div class="page-group-title"><span>基本信息</span></div>
        <table v-if="data" class="info-table" width="100%">
            <tr>
                <th>头像</th>
                <td>
                    <el-image v-if="data.userAvatar" class="userAvatar" :src="data.userAvatar" fit="cover" :preview-src-list="[...data.userAvatar]"></el-image>
                    <span v-else class="color-danger">无</span>
                </td>
            </tr>
            <tr>
                <th>身份</th>
                <td>{{userType.get(data.userType)}}</td>
            </tr>
            <tr>
                <th>ID</th>
                <td>{{data.userId}}</td>
            </tr>
            <tr>
                <th>用户名</th>
                <td>{{data.userName}}</td>
            </tr>
            <tr>
                <th>负责人姓名</th>
                <td>{{data.headName}}</td>
            </tr>
            <tr>
                <th>负责人手机</th>
                <td>{{data.headTelephone}}</td>
            </tr>
            <tr>
                <th>负责人邮箱</th>
                <td>{{data.headMail}}</td>
            </tr>
            <tr>
                <th>风格</th>
                <td>{{data.userStyles}}</td>
            </tr>
            <tr>
                <th>主风格</th>
                <td>{{ mainStyleName }}</td>
            </tr>
            <tr>
                <th>省份城市</th>
                <td>{{data.province}} {{data.city}}</td>
            </tr>
            <tr>
                <th>地址</th>
                <td>{{data.userAddress}}</td>
            </tr>
        </table>

        <div class="group MT20">
            <div class="page-group-title"><span>认证信息</span></div>
            <table v-if="data" class="info-table" width="100%">
                <tr>
                    <th>认证性质</th>
                    <td>{{data.claimType == 1 ? '个人' : '企业'}}</td>
                </tr>
                <template v-if="data.claimType == 1">
                    <tr>
                        <th>认证人姓名</th>
                        <td>{{data.corporationName}}</td>
                    </tr>
                    <tr>
                        <th>认证人证件类型</th>
                        <td>{{data.corporationCodeName}}</td>
                    </tr>
                    <tr>
                        <th>认证人证件号码</th>
                        <td>{{data.corporationId}}</td>
                    </tr>
                    <tr>
                        <th>认证人证件</th>
                        <td>
                            <template v-for="(item,index) in data.corporationIdPic">
                                <el-image :src="item" :key="index" fit="scale-down" :preview-src-list="data.corporationIdPic"></el-image>
                            </template>
                        </td>
                    </tr>
                </template>
                <template v-if="data.claimType == 2">
                    <tr>
                        <th>企业名称</th>
                        <td>{{data.companyName}}</td>
                    </tr>
                    <tr>
                        <th>营业执照编号</th>
                        <td>{{data.licenseId}}</td>
                    </tr>
                    <tr>
                        <th>营业执照</th>
                        <td>
                            <template v-for="(item,index) in data.licensePic">
                                <el-image :src="item" :key="index" fit="scale-down" :preview-src-list="data.licensePic"></el-image>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <th>法人代表姓名</th>
                        <td>{{data.corporationName}}</td>
                    </tr>
                    <tr>
                        <th>法人代表身份证号码</th>
                        <td>{{data.corporationId}}</td>
                    </tr>
                    <tr>
                        <th>法人代表身份证</th>
                        <td>
                            <template v-for="(item,index) in data.corporationIdPic">
                                <el-image :src="item" :key="index" fit="cover" :preview-src-list="data.corporationIdPic"></el-image>
                            </template>
                        </td>
                    </tr>
					<tr>
					    <th>企业类型</th>
					    <td>{{data.businessType == 0 ? '有限责任公司（自然人投资或控股）' : '股份有限公司'}}</td>
					</tr>
					<tr>
					    <th>注册地址</th>
					    <td>{{data.registeredAddress}}</td>
					</tr>
					<tr>
					    <th>注册资本</th>
					    <td>{{data.registeredCapitalStr}}万元</td>
					</tr>
                </template>
                <tr>
                    <th>额外补充信息</th>
                    <td>
                        <template v-for="(item,index) in data.otherPic">
                            <el-image :src="item" :key="index" fit="scale-down" :preview-src-list="data.otherPic"></el-image>
                        </template>
                    </td>
                </tr>
            </table>
        </div>

        <div class="group MT20">
            <div class="page-group-title"><span>审核信息</span></div>
            <table v-if="data" class="info-table" width="100%">
                <tr>
                    <th>提交审核时间</th>
                    <td>{{data.createTime}}</td>
                </tr>
                <tr>
                    <th>审核状态</th>
                    <td>{{status.get(data.status)}}</td>
                </tr>
                <tr>
                    <th>审核人</th>
                    <td>{{data.opUserName}}</td>
                </tr>
                <tr>
                    <th>审核时间</th>
                    <td>{{data.opTime}}</td>
                </tr>
                <tr>
                    <th>备注</th>
                    <td>{{data.remarks}}</td>
                </tr>
            </table>
        </div>
        <div class="btns MT20">
            <el-button @click="goBack">返回</el-button>
            <template v-if="data && data.status == 1">
                <el-button type="primary" @click="formData.status=2;drawerShow=true;">通过</el-button>
                <el-button type="danger" @click="formData.status=3;drawerShow=true;">拒绝</el-button>
            </template>
        </div>

        <!-- 审核 -->
        <el-drawer
            :title="formData.status == 2 ? '通过' : '拒绝'"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content">
                <el-alert show-icon type="warning" :closable="false" :title="`是否确认${formData.status == 2 ? '通过审核' : '拒绝通过'}?`"></el-alert>
                <el-form
                    :model="formData"
                    ref="formData"
                    label-position="top"
                    class="MT20"
                >
                    <el-form-item prop="remark" label="审核备注:" :rules="[{required: formData.status == 3 ? true : false, message: '请输入审核备注'}]">
                        <el-input v-model="formData.remark" type="textarea" :rows="4" maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button v-if="formData.status == 2" type="primary" @click="submitForm()" :loading="btnLoading"
                    >通过</el-button
                >
                <el-button v-else type="danger" @click="submitForm()" :loading="btnLoading"
                    >拒绝</el-button
                >
            </div>
        </el-drawer>
    </div>
</template>

<script>
import baseData from '@/assets/js/baseData';

export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    data(){
        return{
            dataLoading:false,
            data:null,
            redirect: this.$route.query.redirect,
            drawerShow: false,
            formData:{
                remark:'',
                status:2
            },
            btnLoading:false
        }
    },
    computed:{
        mainStyleName() {
            if (!this.data || !this.data.mainStyleId) {
                return '无';
            }
            const item = baseData.mainStyle.find(v => v.value === this.data.mainStyleId);
            return item ? item.name : '-';
        },
        userType(){
            return new Map([
                [1,'粉丝'],
                [2,'艺人'],
                [3,'场地'],
                [4,'赞助商'],
                [5,'厂牌']
            ])
        },
        status(){
            return new Map([
                [0,'流程中'],
                [1,'待审核'],
                [2,'已通过'],
                [3,'已拒绝']
            ])
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            this.dataLoading = true
            this.$request({
                url: "/userClaim/detail",
                method: "POST",
                data: {
                    claimId: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.data.corporationIdPic = this.data.corporationIdPic ? this.data.corporationIdPic.split(',') : [];
                        this.data.otherPic = this.data.otherPic ? this.data.otherPic.split(',') : [];
                        this.data.licensePic = this.data.licensePic ? this.data.licensePic.split(',') : [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },

        close() {
            this.$refs['formData'].clearValidate();
            this.$refs['formData'].resetFields();
            this.drawerShow = false;
        },
        //审核
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/userClaim/operation',
                        method: "POST",
                        data: {...this.formData,claimId: this.id},
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$message.success("操作成功");
                                this.close();
                                this.getData();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.info-table{
    th{
        width: 140px;
    }
    td{
        .el-image{
            width: 200px;
            height: 120px;
            margin: 5px;
            background:#f8f8f8;
            &.userAvatar{
                width: 150px;
                height: 150px;
            }
        }
    }
}
</style>